import gsap from "gsap";
import ScrollLocker from "@/components/ScrollLocker";

export default class MobileNavigationController {

    constructor() {
        this.init();
        this.locker = new ScrollLocker();
    }

    init() {

        let mobileNavTrigger = document.querySelector(".js-mobile-navigation-trigger");
        let mobileNav = document.querySelector(".js-mobile-navigation-wrapper");
        let mobileNavItems = document.querySelectorAll(".js-mobile-navigation-item");

        if (mobileNavTrigger === null) {
            return;
        }

        mobileNavTrigger.addEventListener("click", () => {

            if (!mobileNavTrigger.classList.contains("is-active")) {
                mobileNavTrigger.classList.add("is-active");
                this.locker.lockScroll();
                gsap.to(mobileNav, {
                    autoAlpha: 1,
                });
                gsap.to(mobileNavItems, {
                    stagger: 0.05,
                    autoAlpha: 1,
                    delay: 0.3,
                });
            } else {
                mobileNavTrigger.classList.remove("is-active");
                this.locker.unlockScroll();
                gsap.to(mobileNavItems, {
                    stagger: -0.05,
                    autoAlpha: 0,
                    onComplete: () => {
                        gsap.to(mobileNav, {
                            autoAlpha: 0,
                        });
                    },
                });
            }

        });

    }

}
